import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionGroup, User } from './master-editar-perfil-acesso.models';
import { environment } from '@env/environment';
import { Observable, of, throwError } from 'rxjs';
const BASE_PATH = environment.basePath;


@Injectable({
  providedIn: 'root'
})
export class MasterEditarPerfilAcessoService {

  constructor(private httpClient: HttpClient
    ) { }


  getPermissionGroups(payload?: any): Observable<PermissionGroup[]>{
      return this.httpClient.post<PermissionGroup[]>(`${BASE_PATH}/bff/master/access-profile/edit/profiles/permissions/list`, payload);
  }

  getUsers(payload: any): Observable<any> {
    return this.httpClient.post<any>(`${BASE_PATH}/bff/master/access-profile/users/list/profile`, payload);
  }

  editUsers(users: User[]): Observable<User[]>{
    return this.httpClient.put<User[]>(`${BASE_PATH}/bff/master/access-profile/users/profile/edit`, users)
  }

  editPermissionGroups(permissionGroup): Observable<PermissionGroup> {
    return this.httpClient.put<PermissionGroup>(`${BASE_PATH}/bff/master/access-profile/profiles/edit`, permissionGroup)
  }

  verifyProfile(profileName: string): Observable<any>{

    const payload = {"name": profileName};
    return this.httpClient.post<any>(`${BASE_PATH}/bff/master/access-profile/profiles/edit/verifyIfExists`, payload);
  }

}
